import { BrandColors } from '../theme';

export const radiobuttonTokens = {
    root: {
        background: BrandColors.surface[0],
        checkedBackground: BrandColors.surface[0],
        checkedHoverBackground: 'none',
        disabledBackground: BrandColors.surface[100],
        borderColor: BrandColors.semantic.border,
        hoverBorderColor: BrandColors.primary[400],
        //focusBorderColor: BrandColors.primary[500],
        checkedBorderColor: BrandColors.primary[500],
        checkedHoverBorderColor: BrandColors.primary[600],
    },
};
